import { subDays } from 'date-fns';

const today = new Date();
const yesterday = subDays(today, 1);
const oneYearAgo = subDays(today, 364);

export const MIN_STATISTICS_DATE = oneYearAgo;

export const MAX_STATISTICS_DATE = yesterday;
